import React from "react";
import { Box } from "@mui/material";
import PaymentMethodIcon, { isUpiMethod } from "./PaymentMethodIcon";

const OrderSuccessReceipt = ({ orderReport, formatpaymentTime, OrderSuccessImg }) => {
  const refundInfo = orderReport?.data?.refundDetailInfoList?.[0];
  const items = orderReport?.data?.orderLineItem || [];

  return (
    <>
      <div style={{ marginTop: "5vw" }}>
        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "10vw" }}>
          <Box
            component="img"
            src={OrderSuccessImg}
            alt="Order Success"
            sx={{ maxHeight: 155, borderRadius: 2, width: "130px", height: "130px" }}
          />
        </Box>
      </div>

      <div className="rounded-lg p-3 mb-4" style={{  }}>
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Order :</span> {items.length} Items
        </p>
        <hr style={{ marginTop: "4vw", marginBottom: "2vw" }} />
        <div className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs border-gray-300 ">
          <div style={{textAlign:"start"}}>Item(Count)</div>
          <div>Price Per Unit</div>
          <div style={{marginRight:"2vw"}}>Status</div>
        </div>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800"
            style={{ fontSize: "10px" }}
          >
            <div style={{textAlign:"start"}}>
              {item.variantName.length > 20
                ? item.variantName.slice(0, 20) + "..."
                : item.variantName}{" "}
              ({String(item.itemQuantity).padStart(2, "0")})
            </div>
            <div>₹ {item.amount}</div>
            <div className="text-red-500 font-medium">
              {item.successQuantity > 0 && (
                <span
                  style={{
                    color: "#000000B2",
                    fontSize: "10px",
                    fontFamily: "roboto",
                    fontWeight: "700",
                  }}
                >
                  Success({item.successQuantity})
                </span>
              )}{" "}
              {item.failureQuantity > 0 && (
                <span
                  style={{
                    color: "#E65C5C",
                    fontSize: "10px",
                    fontFamily: "roboto",
                    fontWeight: "700",
                  }}
                >
                  Failed({item.failureQuantity})
                </span>
              )}{" "}
              {item.vendRemaining > 0 && (
                <span
                  style={{
                    color: "#F28618",
                    fontSize: "10px",
                    fontFamily: "roboto",
                    fontWeight: "700",
                  }}
                >
                  Pending({item.vendRemaining})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg p-3" style={{ }}>
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Paid Amount :</span> ₹ {refundInfo?.paidAmount}
        </p>
        <hr style={{ marginTop: "4vw", marginBottom: "2vw" }} />
        <p
          className="text-xs text-gray-600 mt-1"
          style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}
        >
          {formatpaymentTime}
        </p>
        <p
          className="text-xs text-gray-600"
          style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}
        >
          Transaction ID: {refundInfo?.transactionId}
        </p>
        <p
          className="text-xs text-gray-600 mt-2"
          style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}
        >
          Payment Method :{" "}
          <span className="font-medium">{!isUpiMethod(refundInfo?.payMethod) && refundInfo?.payMethod}</span>
          <PaymentMethodIcon method={refundInfo?.payMethod} />
        </p>
      </div>
   <hr/>

                {/*<div style={{display:"flex",position:"absolute",top:"93vw"}}>
        <div style={{width:"30px",height:"30px",background:"rgb(253, 224, 71)",    borderRadius: "30px",  position: "relative",
    left: "-8vw"}}>

        </div>
         <div style={{width:"30px",height:"30px",background:"rgb(253, 224, 71)",borderRadius: "30px",position: "relative",
    right: "-76vw"}}>

        </div> 
        </div>*/}
    </>
  );
};

export default OrderSuccessReceipt;
